import React, { useEffect, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Alert } from "antd";

const ConnectionCheck = ({ healthData, onDataLoad }) => {
  const hasProblem = useMemo(
    () => healthData && healthData === "e",
    [healthData]
  );

  useEffect(() => {
    const interval = setInterval(onDataLoad, hasProblem ? 10000 : 60000);
    return () => interval && clearInterval(interval);
  }, [hasProblem, onDataLoad]);

  return hasProblem ? (
    <Alert
      showIcon
      closable
      type="error"
      className="alert-container"
      message={
        <FormattedMessage
          id="messages.connection.error"
          defaultMessage="Nelze se připojit k serveru, webová aplikace nebude fungovat správně, zkuste to prosím později. Děkujeme."
        />
      }
    />
  ) : (
    <></>
  );
};

export default ConnectionCheck;
